// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpPackPitch-cls1_31A","cls2":"LoswpPackPitch-cls2_ECm LoswpPackPitch-cls1_31A"};